<template>
  <div>
    <GoogleMapsLoader :mapConfig="mapConfig" :id="this.id"></GoogleMapsLoader>
  </div>
</template>


<script>
import GoogleMapsLoader from '../components/GoogleMapsLoader'

export default {
  components: {
    GoogleMapsLoader
  },
  props: ["id"],
  data: function () {
    return {
      mapConfig: {
        center: { lat: 44.97, lng: -93.23 },
        zoom: 10,
      }
    }
  }
}
</script>